import React, { useState, useEffect, useContext } from 'react'
import { detect } from 'detect-browser'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

// utils
import { useAxios } from '../../utils/useAxios'
import colors from '../../styles/colors'
import { getLastPath } from '../../utils/getLastPath'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

export default function Verification({
  minutes,
  seconds,
  setMinutes,
  setSeconds,
  onResponse,
  userId,
  password,
  // ipAddress,
  findId,
  name,
  phoneNum,
  changePassword,
  requestVerificationResetPwd,
  requestVerificationFindId,
  changePwdUserId,
  certificationId,
  setCertificationId,
  setVerificationCode,
  verificationCode,
}) {
  const [rcvdValCode, setRcvdValCode] = useState('')
  const [verificationMsg, setVerificationMsg] = useState('')
  const navigate = useNavigate()
  const browser = detect()

  const { fetchData, loading, data, error } = useAxios()

  useEffect(() => {
    if (data) {
      onResponse(data)
      // 성공
      if (data.responseCode == TYPE.API_RESPONSE.SUCCESS) {
        //signIn();
        const loginInfo = data.responseData.loginInfo

        if (loginInfo) {
          // 로그인 성공 시 로컬스토리지에 유저 정보 저장
          // 이후 약관 동의 여부에 따라 대시보드 or 약관 동의 페이지로 이동 처리
          localStorage.setItem('user', JSON.stringify(loginInfo))
          localStorage.setItem('sessionAlert', '0')

          // 약관 동의 확인
          switch (loginInfo.agreementTermsYn) {
            case 'Y': // 동의 했으면("Y") 홈으로
              navigate('/', { replace: true })
              window.location.reload()

              break

            case 'N': // 동의 안했으면("N") 동의페이지로
              navigate('/useguide', {
                replace: true,
                state: {
                  isTerms: true,
                  agree: 'N',
                },
              })
              window.location.reload()

              break
            case 'R': // 재동의 해야할 경우("R") 동의페이지로
              navigate('/useguide', {
                replace: true,
                state: {
                  isTerms: true,
                  agree: 'R',
                },
              })
              window.location.reload()
              break

            default:
              break
          }
        } else if (data.responseData.certificationId) {
          // 인증번호 재요청
          setVerificationCode(data.responseData.certificationCode)
          setCertificationId(data.responseData.certificationId)
        }
      } else {
        // 실패

        // 인증번호 불일치
        if (data.responseData.certificationCheck == 'N') {
          setVerificationMsg('인증번호가 일치하지 않습니다.')
        }
        if (data.responseData.certificationCheck == 'F') {
          setVerificationMsg('인증번호 재요청 필요합니다.')
          document.getElementById('rcvdValCode').setAttribute('disabled', '')
        }
      }
    }
  }, [data])

  useEffect(() => {
    let sampleInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(sampleInterval)
        } else {
          setMinutes(minutes - 1)
          setSeconds(60 - 1)
        }
      }
      if (seconds === 0 && minutes === 0) {
        setVerificationMsg('입력시간이 초과 되었습니다.')
        setVerificationCode('')
        document.getElementById('rcvdValCode').setAttribute('disabled', '')
      }
    }, 1000)
    return () => {
      clearInterval(sampleInterval)
    }
  })

  // 인증번호 재요청
  const resendVerification = async (e) => {
    setVerificationMsg('')
    document.getElementById('rcvdValCode').value = ''
    // findId 여부
    // console.log('resendVerification findId]]' + findId)
    if (findId) {
      // 아이디 찾기
      requestVerificationFindId()
    }
    // console.log('resendVerification resetPassword]]' + resetPassword)
    // 비밀번호 초기화
    if (changePassword) {
      requestVerificationResetPwd()
    }
    // findId && resetPassword 없으면 인증번호 재요청
    if (changePassword == undefined && findId == undefined) {
      const requestBody = {
        loginId: userId,
        password: password,
        // ip: ipAddress,
      }

      // 로그인 인증번호 발송 /loginCertification
      const params = {}
      fetchData(
        constants.API.LOGIN_CERTIFICATION, // url
        'POST', // method
        requestBody, // data
        params,
      )
    }
    setMinutes(5)
    setSeconds(0)
    document.getElementById('rcvdValCode').removeAttribute('disabled')
  }

  // 아이디 찾기(인증번호 확인)
  const findUserId = async () => {
    const requestBody = {
      userName: name,
      userMobile: phoneNum,
      certificationCode: rcvdValCode,
      certificationId: certificationId,
    }

    // 아이디 찾기 /findIdProc
    fetchData(
      constants.API.FIND_ID_PROC, // url
      'POST', // method
      requestBody, // params
    )
  }

  // 비밀번호 초기화 인증번호 확인 /resetPwdProc
  // const validateResetPwdVerfCode = async () => {
  const validateChangePwdVerfCode = async () => {
    // console.log(resetPwdUserId);
    // console.log(rcvdValCode);
    // console.log(name);
    // console.log(phoneNum);

    const requestBody = {
      loginId: changePwdUserId,
      userName: name,
      userMobile: phoneNum,
      certificationCode: rcvdValCode,
      certificationId: certificationId,
    }

    fetchData(
      constants.API.CHANGE_PWD_PROC, //기존: RESET_PWD_PROC
      'POST', // method
      requestBody, // params
    )
  }

  const homeReload = () => {
    if (getLastPath(window.location.pathname).includes('signin')) {
      window.location.reload()
    }
    navigate('/signin')
  }

  // 로그인 요청(+인증번호)
  const validateVerificationCode = async () => {
    const requestBody = {
      loginId: userId,
      password: password,
      //ip: ipAddress,
      certificationCode: rcvdValCode,
      certificationId: certificationId,
      osName: browser.os ?? '',
      platform: TYPE.PLATFORM.CEO_WEB,
    }

    //
    fetchData(
      constants.API.LOGIN_PROC, // url
      'POST', // method
      requestBody, // params
    )
  }

  // rcvdValCode 인증값 입력
  useEffect(() => {
    setVerificationMsg('')
    // 인증번호 6자리 체크
    if (rcvdValCode.length == 6) {
      document.getElementById('rcvdValCode').value = ''
      setRcvdValCode('')
      //
      if (findId != null) {
        // console.log('findId]]' + findId)
        // id찾기 인증번호
        findUserId()
      } else if (changePassword != undefined || null) {
        // console.log('resetPassword]]' + resetPassword)
        // 비밀번호 초기화 인증번호
        validateChangePwdVerfCode()
      } else {
        // console.log('로그인 인증번호]]')
        // 로그인 인증번호
        validateVerificationCode()
      }
    }
  }, [rcvdValCode])

  useEffect(() => {
    // if (error?.response?.data?.responseCode == 400) {
    // alert('회원 아이디 또는 비밀번호가 일치하지 않습니다.') 인증번호가 일치하지 않습니다.
    // }
  }, [error])

  const handleRcvdValCodeChange = (e) => {
    const regex = /[^0-9]/g
    const filteredVal = e.target.value.replace(regex, '')
    setRcvdValCode(filteredVal)
  }

  return (
    <>
      {minutes == undefined || seconds == undefined ? (
        '  '
      ) : (
        <Wrapper>
          <div>
            <TitleText>인증번호</TitleText>
            {verificationCode}
            <InputWrapper>
              <Input
                className="form-control"
                placeholder="인증번호"
                id="rcvdValCode"
                value={rcvdValCode}
                onChange={handleRcvdValCodeChange}
              />

              <div className="input-group-text border border-0">
                <TimerText>
                  {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </TimerText>
              </div>
            </InputWrapper>
            <ClientMsgWrapper>{verificationMsg}</ClientMsgWrapper>

            <BtnWrapper>
              <CancelBttn onClick={() => homeReload()}>취소</CancelBttn>
              <Button
                onClick={(e) => resendVerification(e, false)}
                id="sendVerfBttn"
              >
                인증번호 재요청
              </Button>
            </BtnWrapper>
          </div>
          {/* <Button
            onClick={(e) => resendVerification(e, false)}
            id="sendVerfBttn"
          >
            <ButtonText>인증번호 재요청</ButtonText>
          </Button> */}
        </Wrapper>
      )}
    </>
  )
}
const Wrapper = styled.div`
  position: absolute;
  bottom: 5%;
  display: flex;
  flex-direction: column;
  width: 100%;

  .form-control::-webkit-outer-spin-button,
  .form-control::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  .form-control {
    border-right: none;
    font-size: 14px;
    text-align: left;
    color: #000;
    @media ${(props) => props.theme.mobile} {
    }
  }
  .input-group:focus,
  .input-group:active {
    outline: none !important;
    box-shadow: none !important;
  }
`
const TitleText = styled.span`
  font-size: 14px;
  color: #00a61c;
  float: left;
  margin-bottom: 10px;
  @media ${(props) => props.theme.mobile} {
  }
`

const InputWrapper = styled.div`
  /* margin: auto; */
  /* width: 360px; */
  width: 100%;
  height: 50px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  border-radius: 7px;
  border: solid 1px #e5e5e5;
  @media ${(props) => props.theme.tablet} {
    margin-bottom: 0;
  }
  @media ${(props) => props.theme.mobile} {
    width: 300px;
    border-radius: 7px;
    border: solid 1px #d8d8d8;
  }
`

const Input = styled.input`
  border: none;
  width: 100%;
  background-color: #fff;
  color: #8a8a8a;
  box-shadow: none !important;
  padding: 10px;
  @media ${(props) => props.theme.mobile} {
  }
`
const TimerText = styled.span`
  font-size: 14px;
  text-align: right;
  color: #d90000;
  @media ${(props) => props.theme.mobile} {
  }
`
const ClientMsgWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  text-align: left;
  color: #d90000;
  padding: 7px 0px;
  margin-bottom: 10px;
  @media ${(props) => props.theme.tablet} {
    padding: 0px;
    margin: 10px 0px 20px;
  }
  @media ${(props) => props.theme.mobile} {
    padding: 7px 0px;
    margin-bottom: 10px;
  }
`

const BtnWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`
const CancelBttn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  color: #04402e;
  cursor: pointer;
  /* @media ${(props) => props.theme.mobile} {
    width: 147px;
    padding: 13px 57px 13px 60px;
  } */
`

const Button = styled.div`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background-color: #00a61c;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  /* @media ${(props) => props.theme.tablet} {
    bottom: 10%;
  }
  @media ${(props) => props.theme.mobile} {
  } */
`
const ButtonText = styled.span`
  @media ${(props) => props.theme.mobile} {
  }
`
